/** @format */

export const position = [
	{
		left: '36%',
		top: '43%',
	},
	{
		left: '50%',
		top: '24%',
	},
	{
		left: '64.5%',
		top: '43%',
	},
	{
		left: '50%',
		top: '63%',
	},
	{
		left: '23%',
		top: '32%',
	},
	{
		left: '35%',
		top: '4%',
	},
	{
		left: '69%',
		top: '3%',
	},
	{
		left: '78%',
		top: '32%',
	},
	{
		left: '7%',
		top: '48%',
	},
	{
		left: '25%',
		top: '90%',
	},
	{
		left: '50%',
		top: '98%',
	},
	{
		left: '75%',
		top: '90%',
	},
	{
		left: '93%',
		top: '48%',
	},
];
